export default "__VITE_ASSET__08804aad__"